import { render, staticRenderFns } from "./TalkBasicPoll.vue?vue&type=template&id=458dbad8&scoped=true&"
import script from "./TalkBasicPoll.vue?vue&type=script&lang=ts&"
export * from "./TalkBasicPoll.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBasicPoll.vue?vue&type=style&index=0&id=458dbad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458dbad8",
  null
  
)

export default component.exports